/* istanbul ignore file */
import { MoneyType } from "../../Money";

/**
 * This object is used to preserve the reference of the amount field in the table.
 * This is a temporary solution for applying the total amount based filtering in the table.
 *
 * By the current experience the precision of the amount is same across the batches. So we are preserving the amount object from the first row.
 * Not an ideal solution, we need to re look at this once when there is way to configure the precision of the amount field.
 */
export default class AmountRefPreserver {
  amountRef?: MoneyType;
}
